export const ERRORES = {
  AlmacenDuplicado: 'Ya existe un registro de almacén con el mismo nombre',
}
